import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '../styles/znap-theme.css'

import en from './locales/en'
import pt from './locales/pt'

const cspnonce = import.meta.env.VITE_CSPNONCE

Vue.use(Vuetify, { cspNonce: cspnonce })

export default new Vuetify({
    lang: {
        current: 'pt',
        locales: { en, pt },
    },
    theme: {
        options: { cspNonce: cspnonce, customProperties: true },
        themes: {
            dark: false,
            light: {},
        },
    },
})
